import { useEffect, useState } from 'react'

import Input from '@/components/form/Input'
import { Translation } from '@/components/i18n/Translation'

import './new-customer-address.scss'

const NewCustomerContact = ({ header, dispatchContact, disabled = false }: any) => {
  const [name, setName] = useState('')
  const [phone, setPhone] = useState('')
  const [email, setEmail] = useState('')

  useEffect(() => {
    dispatchContact({
      name,
      phone,
      email,
    })
  }, [name, phone, email, dispatchContact])

  return (
    <div className="card contact-person">
      {header && <h2>{header}</h2>}

      <Input
        label={<Translation id="Name" />}
        value={name}
        onChange={e => setName(e.target.value)}
        disabled={disabled}
      />

      <Input
        label={<Translation id="Phone" />}
        value={phone}
        onChange={e => setPhone(e.target.value)}
        disabled={disabled}
      />

      <Input
        label={<Translation id="Email" />}
        value={email}
        onChange={e => setEmail(e.target.value)}
        disabled={disabled}
      />
    </div>
  )
}

export default NewCustomerContact
